// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import VueFire from 'vuefire'
const App = () => import('./App')
// import * as firebase from 'firebase'
import firebase from './Firebase/FirebaseInit'
import router from './router'

import { store } from './store'
const AlertCmp = () => import('./components/Shared/Alert.vue')
const firestore = firebase.firestore()
const settings = {timestampsInSnapshots: true}
firestore.settings(settings)

import VueSelectImage from 'vue-select-image'
require('vue-select-image/dist/vue-select-image.css')

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)

Vue.use(VueFire)
Vue.use(VueSelectImage)
Vue.use(Vuetify, {
  theme: {
    primary: '#607FB0',
    secondary: '#0277BD',
    accent: '#FF5722',
    alerts: '#f44336',
    contacts: '#F44336',
    warning: '#F9A825',
    info: '#26A69A',
    deliverable: '#e9652a',
    success: '#7986CB',
    events: '#0277bd',
    todo: '#e4ba4d',
    chat: '#7986cb'
  }
})
Vue.config.productionTip = false
Vue.component('app-alert', AlertCmp)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App},
  created () {
    // firebase.initializeApp({
    //   apiKey: 'AIzaSyCsUdvFP1yYx80TtAxDCCHHEW_KcowkNjM',
    //   authDomain: 'insider-53ef7.firebaseapp.com',
    //   databaseURL: 'https://insider-53ef7.firebaseio.com',
    //   projectId: 'insider-53ef7',
    //   storageBucket: 'insider-53ef7.appspot.com',
    //   messagingSenderId: '1095653283156'
    // })
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }
    })
    // const messaging = firebase.messaging()
    // messaging.usePublicVapidKey('BDT33YYrgkjCFGp7F4JIp_lcQBgU9C43nstL2E5jjUkqmkfGArM4qsGXhqg0pXISLQji_Wv4Ky2ijJdc23wjE_Y')

    // messaging.requestPermission()
    // .then(() => {
    //   messaging.getToken().then(token => {
    //     console.log(`The token is ${token}`)
    //     // Store the token in the firebase db
    //   })
    // }).catch(err => {
    //   console.log(err)
    // })
  }
})



// WEBPACK FOOTER //
// ./src/main.js